const SMS_ENROLL_API_ENDPOINT_PATH = '/enrollment/smsEnroll.json';

function buildSmsEnrollRequest(posContext, phoneNumber) {
  const merchantId = Number(posContext.configurations.merchantId);
  const activationStoreCode = posContext.configurations.storeCode;

  return {
    merchantId,
    activationStoreCode,
    phoneNumber,
  };
}

export async function smsEnroll(posContext, pxContext, phoneNumber) {
  const request = buildSmsEnrollRequest(posContext, phoneNumber);
  const paytronixDomain = posContext.configurations.environmentUrl;

  const response = await fetch(
    `${paytronixDomain}${SMS_ENROLL_API_ENDPOINT_PATH}`,
    {
      body: JSON.stringify(request),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${pxContext.authorizationToken}`,
      },
    }
  ).then((result) => result.json());

  return response;
}
